import { Communication, TCommunicationProps } from "@fluentui/react-teams";
import { Provider } from "@fluentui/react-teams";
import { useRecoilValue } from "recoil";
import { rtThemeNameState } from "states/fluent-ui";
import styled from "styled-components";

/**
 * 의외로 많이 발생하는 @fluentui/react-teams 스타일 문제를 해결하기 위한 css-in-js 입니다. 부모의 높이를 모두 상속받도록 스타일을 설정하였습니다.
 */
const ResetStyle = styled.div`
  width: 100%;
  height: 100%;
  & > div {
    height: 100%;
    & > div {
      /* Communication 컴포넌트가 height: "100vh"로 고정되어 있어 불필요한 공간을 차지하는 현상 제거용 */
      height: 100%;
    }
  }
`;

/**
 * @fluent-ui/react-teams 의 Communication 컴포넌트를 베이스로 여러 기능이 개선된 컴포넌트 입니다.
 */
export default function ReactTeamsCommunication(props: TCommunicationProps) {
  const rtThemeName = useRecoilValue(rtThemeNameState);

  return (
    <ResetStyle>
      <Provider themeName={rtThemeName} lang="en-US">
        <Communication {...props} />
      </Provider>
    </ResetStyle>
  );
}
